import * as React from 'react';

import {FormClosedLeadSlack} from '../../forms/slack/form-closed-lead-slack';

import {SalesAutomationEditorSidebar} from './sidebar/sales-automation-editor-sidebar';

type OwnProps = {
    isNew: boolean;
    entityId: string | null | undefined;
    parentId: string;
};

type Props = OwnProps;

export class ClosedLeadSlackEditor extends React.PureComponent<Props> {
    sidebarFormSubmitBtnRef: HTMLInputElement | null | undefined;

    render() {
        return (
            <SalesAutomationEditorSidebar
                onSave={this.handleSidebarFormSave}
                title={this.props.isNew ? 'Add Slack message' : 'Edit Slack message'}
            >
                <FormClosedLeadSlack
                    formSubmitBtnRef={(node) => {
                        this.sidebarFormSubmitBtnRef = node;
                    }}
                    entityId={this.props.entityId}
                    parentId={this.props.parentId}
                />
            </SalesAutomationEditorSidebar>
        );
    }

    handleSidebarFormSave = () => {
        if (this.sidebarFormSubmitBtnRef) {
            this.sidebarFormSubmitBtnRef.click();
        }
    };
}
